const defaultChartMargin = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
const defaultChartPadding = {
  top: 10,
  right: 10,
  bottom: 10,
  left: 10
};
const NUM_X_AXIS_TICKS_MIN = 3;
const NUM_X_AXIS_TICKS_MAX = 8;
const DEFAULT_X_AXIS_HEIGHT = 26;
const DEFAULT_Y_AXIS_WIDTH = 46;

export { DEFAULT_X_AXIS_HEIGHT, DEFAULT_Y_AXIS_WIDTH, NUM_X_AXIS_TICKS_MAX, NUM_X_AXIS_TICKS_MIN, defaultChartMargin, defaultChartPadding };
//# sourceMappingURL=constants.js.map
